import React from 'react';
import { Spinner } from 'reactstrap';

const FeedbackMessage = ({ message, showSpinner }) => {
    if (!message) return null;

    return (
        <div
            style={{
                color: 'white',
                fontWeight: 'bold',
                fontSize: '13px',
                marginTop: '15px',
                marginBottom: '15px'
            }}
        >
            <span>{message}</span>
            {showSpinner && <Spinner style={{ width: '1.2rem', height: '1.2rem' }} />}
        </div>
    );
};

export default FeedbackMessage;
